import React, { Dispatch } from 'react';

import {
    PaperPlanMetadata,
    PlayType,
    ProgramType,
    RatchetModels
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import Column from '@amzn/meridian/column';

import { AppContext } from 'src/contexts/appContext';
import { IMetadata } from 'src/types/IMetadata';
import { IPrimeAMFRateCardValidationAction } from 'src/types/IPrimeAMFRateCardValidationAction';
import { IPrimeAMFRateCardValuesAction } from 'src/types/IPrimeAMFRateCardValuesAction';
import { IPrimeAMFRateCardValues } from 'src/types/IRateCard';

import { IPrimeAMFRateCardErrors } from '../rateCardValidationReducer';
import { AddAdRevShare } from './AddAdRevShare';
import './AddContractTerms.scss';
import { AddCostPerPlay } from './AddCostPerPlay';
import { AddMonthlyActiveUser } from './AddMonthlyActiveUser';

interface IAddContractTerms {
    rateCardValues: IPrimeAMFRateCardValues;
    dispatchRateCardValues: Dispatch<IPrimeAMFRateCardValuesAction>;
    rateCardErrors: IPrimeAMFRateCardErrors;
    dispatchRateCardErrors: Dispatch<IPrimeAMFRateCardValidationAction>;
    playTypes: PlayType[];
    customerTypes: PaperPlanMetadata[];
    programTypes: ProgramType[];
    conversionModels: RatchetModels;
    augmentedMetadata: IMetadata;
}

export const AddContractTerms: React.FC<IAddContractTerms> = ({
    rateCardValues,
    dispatchRateCardValues,
    rateCardErrors,
    dispatchRateCardErrors,
    playTypes,
    customerTypes,
    programTypes,
    conversionModels,
    augmentedMetadata
}) => {
    const { metadata } = React.useContext(AppContext);
    const services = metadata.serviceMapping;

    return (
        <Column className="contract-terms-width">
            {rateCardValues.serviceId === services[2].serviceId ? (
                <>
                    <AddCostPerPlay
                        rateCardValues={rateCardValues}
                        dispatchRateCardValues={dispatchRateCardValues}
                        rateCardErrors={rateCardErrors}
                        dispatchRateCardErrors={dispatchRateCardErrors}
                        playTypes={playTypes}
                        customerTypes={customerTypes}
                        programTypes={programTypes}
                        conversionModels={conversionModels}
                        augmentedMetadata={augmentedMetadata}
                    />
                    <AddMonthlyActiveUser
                        rateCardValues={rateCardValues}
                        dispatchRateCardValues={dispatchRateCardValues}
                        rateCardErrors={rateCardErrors}
                        dispatchRateCardErrors={dispatchRateCardErrors}
                        customerTypes={customerTypes}
                    />
                </>
            ) : (
                <AddAdRevShare
                    rateCardValues={rateCardValues}
                    dispatchRateCardValues={dispatchRateCardValues}
                    rateCardErrors={rateCardErrors}
                    dispatchRateCardErrors={dispatchRateCardErrors}
                    playTypes={playTypes}
                    conversionModels={conversionModels}
                    augmentedMetadata={augmentedMetadata}
                />
            )}
        </Column>
    );
};
